import React from 'react';

export default function UserManagementGroupsTab(): JSX.Element {
  return <div className="w-full mt-[3.2rem] mx-auto py-6 px-dashboard-side bg-dashboard-background">Groups tab</div>;
}
